export const operationPath = (pageNumber, type) => `/api/v2/profile/${type}?page=${pageNumber}.json`;
